const {createPipeline} = require("cleopatra");
const router = require("app/services/router");
const axios = require("axios");
const env = require("app/services/env");
const {createPromiseThrottle} = require("app/util/throttle");
const {reportAndThrow} = require("app/util/errors");
const manager = require("app/pipelines/checkout/manager");

/////////////////////////////////
// Functions
/////////////////////////////////

function addCartIdToRequest(payload) {
	const cartId = env.get("checkout.cart.products.guid");
	payload instanceof FormData ?
		payload.append("cart_id", cartId) :
		(payload.cart_id = cartId);

	return payload;
}

function addReferrerToRequest(payload) {
	payload instanceof FormData ?
		payload.append("referrer", location.pathname) :
		(payload.referrer = location.pathname);

	return payload;
}

function currentCart() {
	return env.get("checkout.cart.products");
}

/////////////////////////////////
// Cart change pipeline
/////////////////////////////////

const change = createPipeline().report(reportAndThrow);

change.pipe(payload => {
	if (payload && typeof payload === "object") {
		env.set("checkout.cart.products", payload);

		if (payload.dataLayer) {
			window.cartDataLayer.splice(0, window.cartDataLayer.length, ...payload.dataLayer);
		}
	}

	return payload;
});

/////////////////////////////////
// Add product
/////////////////////////////////

const throttleAdd = createPromiseThrottle(250);
let add = {};

add.request = createPipeline().report(reportAndThrow);
add.response = createPipeline().report(reportAndThrow);

add.request.pipe(payload => {
	return throttleAdd(payload);
});

add.request.pipe(addCartIdToRequest);

add.request.capture(payload => {
	return axios.post(router.route("api.checkout.products.add"), payload).then(response => {
		return add.response.dispatch(response.data);
	});
});

add.response.capture(change);

/////////////////////////////////
// Remove product
/////////////////////////////////

let remove = {};

remove.request = createPipeline().report(reportAndThrow);
remove.response = createPipeline().report(reportAndThrow);

remove.request.pipe(addCartIdToRequest);
remove.request.capture(payload => {
	return axios.post(router.route("api.checkout.products.remove"), payload).then(response => {
		return remove.response.dispatch(response.data);
	});
});

remove.response.capture(change);

/////////////////////////////////
// Text card
/////////////////////////////////

let textCard = {};

textCard.update = createPipeline().report(reportAndThrow);
textCard.update.pipe(addCartIdToRequest);
textCard.update.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.text-card.update"), payload)
		.then(response => response.data);
});

textCard.update.capture(change);

/////////////////////////////////
// Ribbon
/////////////////////////////////

let ribbon = {};

ribbon.update = createPipeline().report(reportAndThrow);
ribbon.update.pipe(addCartIdToRequest);
ribbon.update.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.ribbon.update"), payload)
		.then(response => response.data);
});

ribbon.update.capture(change);

/////////////////////////////////
// Delivery
/////////////////////////////////

let delivery = {};

delivery.update = createPipeline().report(reportAndThrow);
delivery.update.pipe(addCartIdToRequest);
delivery.update.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.delivery.update"), payload)
		.then(response => response.data);
});

delivery.update.capture(change);

/////////////////////////////////
// Discount
/////////////////////////////////

let discount = {};
discount.update = createPipeline().report(reportAndThrow);

discount.update.pipe(addCartIdToRequest);
discount.update.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.discount.update"), payload)
		.then(response => response.data);
});

discount.update.capture(change);

/////////////////////////////////
// Recipient
/////////////////////////////////

let recipient = {};
recipient.validate = createPipeline().report(reportAndThrow);
recipient.update = createPipeline().report(reportAndThrow);

recipient.validate.pipe(addCartIdToRequest);
recipient.validate.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.recipient.validate"), payload)
		.then(response => response.data);
});

//recipient.validate.capture(change);

recipient.update.pipe(addCartIdToRequest);
recipient.update.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.recipient.update"), payload)
		.then(response => response.data);
});

recipient.update.capture(change);

/////////////////////////////////
// Client
/////////////////////////////////

let client = {};
client.validate = createPipeline().report(reportAndThrow);
client.update = createPipeline().report(reportAndThrow);

client.validate.pipe(addCartIdToRequest);
client.validate.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.client.validate"), payload)
		.then(response => response.data);
});

//client.validate.capture(change);

client.update.pipe(addCartIdToRequest);
client.update.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.client.update"), payload)
		.then(response => response.data);
});

client.update.capture(change);

/////////////////////////////////
// Order
/////////////////////////////////

let order = {};

order.place = createPipeline().report(reportAndThrow);
order.place.pipe(addCartIdToRequest);
order.place.pipe(addReferrerToRequest);
order.place.pipe(payload => {
	return axios
		.post(router.route("api.checkout.products.order.place"), payload)
		.then(response => response.data);
});

order.place.capture(cart => {
	// REDIRECT TO PAYMENT
	if (cart.redirect) {
        window.location = cart.redirect;
	}
});

// order.place.capture(cart => {
// 	if (cart.status === "expecting_payment") {
// 		window.location = router.route("checkout.payment", {guid: cart.guid});
// 		return cart;
// 	}
//
// 	if (cart.status === "complete") {
//
// 		//redirect
// 		window.location = router.route("checkout.receipt", {guid: cart.guid});
// 		return cart;
// 	}
//
// });

/////////////////////////////////
// Clear
/////////////////////////////////

let clear = {};

clear.request = createPipeline().report(reportAndThrow);
clear.response = createPipeline().report(reportAndThrow);

clear.request.pipe(addCartIdToRequest);
clear.request.capture(payload => {
	return axios
		.post(router.route("api.checkout.products.clear"), payload)
		.then(response => clear.response.dispatch(response.data));
});

clear.requestAndRedirect = createPipeline().report(reportAndThrow);

clear.requestAndRedirect.pipe(addCartIdToRequest);
clear.requestAndRedirect.capture(payload => {
	return axios
		.post(router.route("api.checkout.products.clear"), payload)
		.then(response => response.data)
		.then(cart => axios.post(router.route("checkout.product.use-cart", {guid: cart.guid})))
		.then(() => {
			window.location = payload.location;
		});
});

clear.response.capture(cart => {
	if (currentCart().guid !== cart.guid) {
		return axios.post(router.route("checkout.product.use-cart", {guid: cart.guid})).then(() => {
			window.location = router.currentUrl + "#indkobskurv";
			window.location.reload();
			//change.dispatch(cart);
		});
	}

	// Redirect away from payment window
	// if the cart was "cleared" (to be edited)
	if (router.currentRoute === "checkout.product.payment") {
		window.location = router.url(cart.referrer || "") + "#indkobskurv";
		return false;
	}

	return manager.close.dispatch()
		.then(() => change.dispatch(cart))
		.then(() => manager.open.dispatch({cart: "product"}))
		.then(() => cart);
});

module.exports = {
	add,
	remove,
	change,
	delivery,
	discount,
	recipient,
	client,
	order,
	clear,
	textCard,
	ribbon
};
